// Mock data for the Project Stark landing page (frontend-only)
// Colors adapted from Myrickey.cc (monochrome black & white theme)

export const siteConfig = {
  title: "MinirickHub",
  tagline: "Sleek design. Premium, in a free package.",
  year: 2026,
};

export const actions = [
  {
    id: "discord",
    label: "Discord",
    variant: "secondary",
    href: "https://discord.gg/MSf9CZ2p37",
  },
  {
    id: "loadstring",
    label: "Loadstring",
    variant: "secondary",
  },
  {
    id: "key",
    label: "Key",
    variant: "primary",
  },
];

// Acortadores entre los que el usuario elige al pulsar "Key".
// href = tu enlace real creado en cada plataforma (el que compartes).
// El destino final configurado en el panel de cada una debe ser
// exactamente: https://minirick.uk/gate (igual en las tres, sin parámetros).
export const lockers = [
  {
    id: "linkvertise",
    label: "Linkvertise",
    variant: "linkvertise", // naranja
    href: process.env.REACT_APP_LINKVERTISE_URL,
  },
  {
    id: "lootlabs",
    label: "LootLabs",
    variant: "lootlabs", // morado
    href: process.env.REACT_APP_LOOTLABS_URL,
  },
  {
    id: "workink",
    label: "Work.ink",
    variant: "workink", // verde
    href: process.env.REACT_APP_WORKINK_URL,
  },
];

// keyData ya no es mock: KeyDashboard.jsx lo obtiene en vivo desde
// el Worker de Cloudflare (ver src/lib/keyApi.js).
